export default __webpack_public_path__ + "static/media/woodBg.d6456202.png";